import {createBrowserHistory as createHistory} from 'history';
import isEmpty from 'lodash/isEmpty';
import {BASE_URL_REGEX, APPID_REGEX, REDEMPTION_URL_REGEX} from './configs/constants';

const isTest = process.env.NODE_ENV === 'test';
const isE2E = process.env.__E2E__;

let baseUrl = '/';
let appIdMatch = ['test_id'];

const {pathname} = window.location;
const redemptionMatches = pathname.match(REDEMPTION_URL_REGEX);

export const isRedemption = !isEmpty(redemptionMatches);

if (!isTest && !isE2E && !isRedemption) {
  const baseMatches = pathname.match(BASE_URL_REGEX);
  if (!isEmpty(baseMatches)) {
    baseUrl = baseMatches && baseMatches[0];
    appIdMatch = baseUrl && baseUrl.match(APPID_REGEX);
  }
}

export const appId = appIdMatch && appIdMatch[0];
export const history = createHistory({basename: baseUrl});
